import * as uuid from 'uuid'
import { store } from '@/store'
import { AccountCommandProcessor } from './AccountCommandProcessor'
import { ErrorHandler } from './../utils/ErrorHandler'

const MAX_CONNECT_USER_TRY_COUNT = 10
export class AccountClient {

  private connectionTryCount: number

  constructor() {
    this.connectionTryCount = 0
  }

  get client() {
    return store.getters.instance
  }

  async connectUser(userData, connectionData = { port: undefined, hostName: undefined, domain: undefined}) {

    if (this.connectionTryCount >= MAX_CONNECT_USER_TRY_COUNT) {
      throw new Error(`Could not connect user ${userData.userIdentity} - Max connection try count of ${MAX_CONNECT_USER_TRY_COUNT} reached. Please refresh the page.`)
    }

    this.connectionTryCount++

    store.commit('setClient', {
      userIdentity: userData.userIdentity,
      userPassword: userData.userPassword,
      port: connectionData.port,
      hostName: connectionData.hostName,
      domain: connectionData.domain,
    })

    try {
      await this.client.connect()
      this.connectionTryCount = 0
      console.log('User connected with success')
    } catch (e) {
      console.log('Error connecting user', 'Exception', e)

      if (e.reason && e.reason.code === 13) {
        await this.client.close()
        console.log('Connection closed ... Creating new account')
        const newAccount = await this.createNewAccount(userData, connectionData)
        await this.connectNewUser(userData, connectionData)

        return newAccount
      } else {

        this.client._transport.onClose = () => {}
        this.client.close()

        return new Promise((resolve, reject) => {
          // Use an exponential backoff for the timeout
          const timeout = 100 * Math.pow(2, this.connectionTryCount)
          setTimeout(async () => {
            console.log('Retrying - Connect user ...')
            const newAccount = await this.connectUser(userData, connectionData)
            resolve(newAccount)
          }, timeout)
        })
      }
    }

    this.client.sessionPromise.catch((s) => {
      switch (s.reason.code) {
        case 11:
          console.log(
            'Closing current connection because another has been started',
          )
          break
        case 13:
          console.log('Invalid credentials, closing current connection...')
          break
      }
    })
  }

  async connectNewUser(userData, connectionData) {
    store.commit('setClient', {
      userIdentity: userData.userIdentity,
      userPassword: userData.userPassword,
      port: connectionData.port,
      hostName: connectionData.hostName,
      domain: connectionData.domain,
    })

    try {
      await this.client.connect()
      console.log('New user connected with success')

      return
    } catch (e) {
      console.log('Error connecting new user')
      throw e
    }
  }

  async createNewAccount(userData, connectionData) {
    try {
      store.commit('setClient', {
        userIdentity: userData.userIdentity,
        userPassword: userData.userPassword,
        port: connectionData.port,
        hostName: connectionData.hostName,
        domain: connectionData.domain,
      })

      await this.client.connectWithGuest(uuid.v4())
      console.log('Connected as guest')

      const accountData = {
        password: userData.userPassword,
        email: userData.email ? userData.email : userData.userEmail,
        fullName: userData.fullName ? userData.fullName : userData.userName,
        ...userData,
      }

      try {
        await AccountCommandProcessor.create(userData.userIdentity, accountData)
        console.log('Create new account for user')

        await this.client.close()

        return { ...accountData, userIdentity: userData.userIdentity }
      } catch (e) {
        console.log('Error creating account', e)
        ErrorHandler.handle(e, 'AccountClient - Create account')
        throw e
      }
    } catch (e) {
      console.log('Error connecting as guest', e)
      throw e
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/api/AccountClient.ts